/**
 * Video library for /watch. To add a new video, append a new entry to
 * VIDEOS — no UI changes needed. Categories are defined in CATEGORIES;
 * a video belongs to exactly one category (its position in the tab filter).
 *
 * All i18n keys live in `src/i18n/translations.js` under `watch.video.*`
 * and `watch.cat.*`.
 *
 *  videoId    — YouTube ID (used for embed + thumbnail)
 *  category   — slug, must match an entry in CATEGORIES
 *  titleKey   — i18n key for the title shown under the player
 *  captionKey — i18n key for the short caption / description
 *  eyebrowKey — i18n key for the small uppercase label above the title
 *  publishedAt— ISO date (for sorting; latest first)
 *  featured   — exactly one entry should be featured (renders large at top)
 *  status     — "published" | "coming-soon"  (coming-soon shows a placeholder card)
 */

export const CATEGORIES = [
  { slug: "all",        labelKey: "watch.cat.all" },
  { slug: "trailer",    labelKey: "watch.cat.trailer" },
  { slug: "marcus",     labelKey: "watch.cat.marcus" },
  { slug: "seneca",     labelKey: "watch.cat.seneca" },
  { slug: "epictetus",  labelKey: "watch.cat.epictetus" },
  { slug: "cato",       labelKey: "watch.cat.cato" },
  { slug: "tutorials",  labelKey: "watch.cat.tutorials" },
  { slug: "updates",    labelKey: "watch.cat.updates" },
];

export const VIDEOS = [
  {
    videoId: "zyKKUkOfgxU",
    category: "trailer",
    titleKey: "watch.video.trailer.title",
    captionKey: "watch.video.trailer.caption",
    eyebrowKey: "watch.video.trailer.eyebrow",
    publishedAt: "2026-02-01",
    featured: true,
    status: "published",
  },
  // Future entries, e.g.:
  // { videoId: "<id>", category: "marcus",    titleKey: "watch.video.marcus1.title",    ... },
  // { videoId: "<id>", category: "tutorials", titleKey: "watch.video.tutorial1.title",  ... },
];
